/* @flow */
import Store from 'lib/Store';
import Leads from 'collections/Leads';
import { ActionTypes } from 'constants/LeadConstants';

class LeadStore extends Store {
  getInitialState() {
    return {
      leads: new Leads(),
      userIdToLead: {},
      loaded: false,
    };
  }

  getLeads() {
    return this.state.leads;
  }

  getLeadsForOrganization(id) {
    return new Leads(this.state.leads.filter(lead => {
      return lead.getOrganizationId() === id;
    }));
  }

  getLeadForUser(userId) {
    return this.state.userIdToLead[userId];
  }

  addLead(lead, userId = null) {
    this.state.leads.add(lead);

    if (userId) {
      this.state.userIdToLead[userId] = lead;
    }
  }

  handleLoad(leads) {
    this.state.leads = leads;
    this.state.loaded = true;
    this.emitChange();
  }

  isLoaded() {
    return this.state.loaded;
  }

  handleDispatch(action: Object): void {
    switch (action.type) {
      case ActionTypes.LOAD_LEAD:
        this.addLead(action.lead, action.userId);
        this.emitChange();
        break;
      case ActionTypes.LOAD_LEADS:
        this.handleLoad(action.leads);
        break;
      default:
        break;
    }
  }
}

export default new LeadStore();



// WEBPACK FOOTER //
// ./src/stores/LeadStore.js